import React, { ComponentProps } from 'react';
import { TableRow as CarbonTableRow } from '@carbon/react';

export type TableRowProps = ComponentProps<typeof CarbonTableRow>;

export const TableRow = (props: TableRowProps) => <CarbonTableRow {...props} />;

TableRow.displayName = 'TableRow';
